/* tslint:disable */
/* eslint-disable */
import { gql } from "@apollo/client";

export const GET_AGENCY = gql`
  query getAgency {
    getAgency {
      id
      name
      timezone
      address {
        accuracy
        additionalInfo
        city
        country
        county
        formattedAddress
        label
        name
        number
        postalCode
        state
        stateShort
        street
        streetAddress
        sublocality
        time
        validatedAt
      }
      issueDispatchingMethod
      disabledIssueTypes
      deletedDefaultConditions
      areOnboardingResultsEnabled
      taskTypes
      canCreateTask
      configured
      email
      contact {
        firstName
        lastName
        email
        cellPhone
        officePhone
      }
      enableBackupData
      inclusionZoneViolationThresholdInSeconds
      participantNotOnboardedNotification {
        notOnboardedMethod
        email
      }
      courtReportNotification {
        method
        email
      }
      missedCheckInGapInMinutes
      paymentOptions {
        type
        participantOneTimeFee
        participantMonthlyFee
      }
      sessionTimeoutMins
      questionPeriod
      missedCheckinInRowWarningThreshold
      recordVideoChat
      parentId
      autoCloseIssue
      type
      placesEnabled
      peopleEnabled
      timeline
      lastCalculatedSnapshotDate
      receiveEmailIfNotOnboarded
      isTrackingInsideSafeZones
      canAccessParticipantWebapp
    }
  }
`;
